import React from 'react';
import '../styles/Input.css';

interface InputProps {
  value: string;
  type: string;
  changeValue?: (value: string) => void; // Made optional
  label?: string; // Made optional
  placeholder: string;
  readOnly?: boolean; // Added readOnly prop
  className?: string; // Added className prop
}

/**
 *
 * @param props value: string to be displayed in the input
 * @param props type: type of input
 * @param props changeValue: function to be called when the input is changed (optional)
 * @param props label: label of the input (optional)
 * @param props placeholder: placeholder of the input
 * @param props readOnly: whether the input is read-only (optional)
 * @param props className: additional CSS classes for the input (optional)
 *
 * @returns an input component configured with the given props
 */
const Input: React.FC<InputProps> = ({
  value,
  type,
  changeValue,
  label,
  placeholder,
  readOnly = false,
  className = '',
}) => {
  return (
    <div className="w-full">
      {label && <label className="text-[#7db4e5] text-[12px] mb-2">{label}</label>}
      <input
        type={type}
        placeholder={placeholder}
        value={value}
        onChange={changeValue ? (e) => changeValue(e.target.value) : undefined}
        readOnly={readOnly}
        className={`bg-transparent text-[16px] w-full text-white ${className}`}
        required={!readOnly}
        min = "0"
      />
    </div>
  );
};

export default Input;